import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

type Props = {
  rowsPerPage: number;
  rowsPerPageMenu: number[];
  label?: string;
  onChange: (value: number) => void;
};

export default class RowsPerPage extends React.Component<Props> {
  render() {
    const { rowsPerPage, rowsPerPageMenu, onChange, label } = this.props;

    if (label) {
      return (
        <FormControl fullWidth>
          <InputLabel id="per-page-dropdown">{label}</InputLabel>
          <Select
            labelId="per-page-dropdown"
            value={rowsPerPage}
            label={label}
            variant="standard"
            onChange={(e) => onChange(Number(e.target.value))}
            MenuProps={{
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              transformOrigin: { vertical: 'top', horizontal: 'left' },
            }}
          >
            {rowsPerPageMenu.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return (
      <FormControl variant="standard" className="rows-per-page-control">
        <Select
          value={rowsPerPage}
          variant="standard"
          disableUnderline
          onChange={(e) => onChange(Number(e.target.value))}
          MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
          }}
        >
          {rowsPerPageMenu.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}
